module.exports = __webpack_public_path__ + "static/Apple iPhone 8 Silver-bf8410520a1d1ce3175ecac64844a8d0.png";